import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { ExtendPrototype } from '../state/core';

@Component({
    selector: 'app-ticket-complete',
    templateUrl: './ticket-complete.component.html',
    styleUrls: ['./ticket-complete.component.css'],
    standalone: false
})
@ExtendPrototype({
  persistStateOnRefresh: true
})
export class TicketCompleteComponent {
  public ticket_id = 0;

  constructor(route: ActivatedRoute) {
    route.params.subscribe(params => {
      this.ticket_id = params['ticketId'];
    });
  }
}
